/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  BarChartStatsList,
  PieChartStatsList,
  ShipsOfTheMonthParams,
  Stats,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Stats Components by Class
 */
export const componentsByClass = (

 signal?: AbortSignal
) => {


      return axiosClient<PieChartStatsList>(
      {url: `/stats/components-by-class`, method: 'GET', signal
    },
      );
    }




export const getComponentsByClassQueryKey = () => {
    return [
    'stats','components-by-class'
    ] as const;
    }


export const getComponentsByClassQueryOptions = <TData = Awaited<ReturnType<typeof componentsByClass>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentsByClass>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getComponentsByClassQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof componentsByClass>>> = ({ signal }) => componentsByClass(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof componentsByClass>>, TError, TData>
}

export type ComponentsByClassQueryResult = NonNullable<Awaited<ReturnType<typeof componentsByClass>>>
export type ComponentsByClassQueryError = ErrorType<unknown>


/**
 * @summary Stats Components by Class
 */

export function useComponentsByClass<TData = Awaited<ReturnType<typeof componentsByClass>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof componentsByClass>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getComponentsByClassQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Models by Classification
 */
export const modelsByClassification = (

 signal?: AbortSignal
) => {


      return axiosClient<PieChartStatsList>(
      {url: `/stats/models-by-classification`, method: 'GET', signal
    },
      );
    }




export const getModelsByClassificationQueryKey = () => {
    return [
    'stats','models-by-classification'
    ] as const;
    }


export const getModelsByClassificationQueryOptions = <TData = Awaited<ReturnType<typeof modelsByClassification>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsByClassification>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsByClassificationQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsByClassification>>> = ({ signal }) => modelsByClassification(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsByClassification>>, TError, TData>
}

export type ModelsByClassificationQueryResult = NonNullable<Awaited<ReturnType<typeof modelsByClassification>>>
export type ModelsByClassificationQueryError = ErrorType<unknown>


/**
 * @summary Stats Models by Classification
 */

export function useModelsByClassification<TData = Awaited<ReturnType<typeof modelsByClassification>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsByClassification>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsByClassificationQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Models by Manufacturer
 */
export const modelsByManufacturer = (

 signal?: AbortSignal
) => {


      return axiosClient<PieChartStatsList>(
      {url: `/stats/models-by-manufacturer`, method: 'GET', signal
    },
      );
    }




export const getModelsByManufacturerQueryKey = () => {
    return [
    'stats','models-by-manufacturer'
    ] as const;
    }


export const getModelsByManufacturerQueryOptions = <TData = Awaited<ReturnType<typeof modelsByManufacturer>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsByManufacturer>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsByManufacturerQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsByManufacturer>>> = ({ signal }) => modelsByManufacturer(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsByManufacturer>>, TError, TData>
}

export type ModelsByManufacturerQueryResult = NonNullable<Awaited<ReturnType<typeof modelsByManufacturer>>>
export type ModelsByManufacturerQueryError = ErrorType<unknown>


/**
 * @summary Stats Models by Manufacturer
 */

export function useModelsByManufacturer<TData = Awaited<ReturnType<typeof modelsByManufacturer>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsByManufacturer>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsByManufacturerQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Models by Production-Status
 */
export const modelsByProductionStatus = (

 signal?: AbortSignal
) => {


      return axiosClient<PieChartStatsList>(
      {url: `/stats/models-by-production-status`, method: 'GET', signal
    },
      );
    }




export const getModelsByProductionStatusQueryKey = () => {
    return [
    'stats','models-by-production-status'
    ] as const;
    }


export const getModelsByProductionStatusQueryOptions = <TData = Awaited<ReturnType<typeof modelsByProductionStatus>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsByProductionStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsByProductionStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsByProductionStatus>>> = ({ signal }) => modelsByProductionStatus(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsByProductionStatus>>, TError, TData>
}

export type ModelsByProductionStatusQueryResult = NonNullable<Awaited<ReturnType<typeof modelsByProductionStatus>>>
export type ModelsByProductionStatusQueryError = ErrorType<unknown>


/**
 * @summary Stats Models by Production-Status
 */

export function useModelsByProductionStatus<TData = Awaited<ReturnType<typeof modelsByProductionStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsByProductionStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsByProductionStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Models by Size
 */
export const modelsBySize = (

 signal?: AbortSignal
) => {


      return axiosClient<PieChartStatsList>(
      {url: `/stats/models-by-size`, method: 'GET', signal
    },
      );
    }




export const getModelsBySizeQueryKey = () => {
    return [
    'stats','models-by-size'
    ] as const;
    }


export const getModelsBySizeQueryOptions = <TData = Awaited<ReturnType<typeof modelsBySize>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsBySize>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsBySizeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsBySize>>> = ({ signal }) => modelsBySize(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsBySize>>, TError, TData>
}

export type ModelsBySizeQueryResult = NonNullable<Awaited<ReturnType<typeof modelsBySize>>>
export type ModelsBySizeQueryError = ErrorType<unknown>


/**
 * @summary Stats Models by Size
 */

export function useModelsBySize<TData = Awaited<ReturnType<typeof modelsBySize>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsBySize>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsBySizeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Models per Month
 */
export const modelsPerMonth = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/models-per-month`, method: 'GET', signal
    },
      );
    }




export const getModelsPerMonthQueryKey = () => {
    return [
    'stats','models-per-month'
    ] as const;
    }


export const getModelsPerMonthQueryOptions = <TData = Awaited<ReturnType<typeof modelsPerMonth>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsPerMonth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getModelsPerMonthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof modelsPerMonth>>> = ({ signal }) => modelsPerMonth(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof modelsPerMonth>>, TError, TData>
}

export type ModelsPerMonthQueryResult = NonNullable<Awaited<ReturnType<typeof modelsPerMonth>>>
export type ModelsPerMonthQueryError = ErrorType<unknown>


/**
 * @summary Stats Models per Month
 */

export function useModelsPerMonth<TData = Awaited<ReturnType<typeof modelsPerMonth>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof modelsPerMonth>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getModelsPerMonthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Most Wishlisted
 */
export const mostWishlisted = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/most-wishlisted`, method: 'GET', signal
    },
      );
    }




export const getMostWishlistedQueryKey = () => {
    return [
    'stats','most-wishlisted'
    ] as const;
    }


export const getMostWishlistedQueryOptions = <TData = Awaited<ReturnType<typeof mostWishlisted>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mostWishlisted>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMostWishlistedQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mostWishlisted>>> = ({ signal }) => mostWishlisted(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mostWishlisted>>, TError, TData>
}

export type MostWishlistedQueryResult = NonNullable<Awaited<ReturnType<typeof mostWishlisted>>>
export type MostWishlistedQueryError = ErrorType<unknown>


/**
 * @summary Stats Most Wishlisted
 */

export function useMostWishlisted<TData = Awaited<ReturnType<typeof mostWishlisted>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mostWishlisted>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMostWishlistedQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Patch Changes
 */
export const patchChanges = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/patch-changes`, method: 'GET', signal
    },
      );
    }




export const getPatchChangesQueryKey = () => {
    return [
    'stats','patch-changes'
    ] as const;
    }


export const getPatchChangesQueryOptions = <TData = Awaited<ReturnType<typeof patchChanges>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patchChanges>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPatchChangesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof patchChanges>>> = ({ signal }) => patchChanges(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof patchChanges>>, TError, TData>
}

export type PatchChangesQueryResult = NonNullable<Awaited<ReturnType<typeof patchChanges>>>
export type PatchChangesQueryError = ErrorType<unknown>


/**
 * @summary Stats Patch Changes
 */

export function usePatchChanges<TData = Awaited<ReturnType<typeof patchChanges>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof patchChanges>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPatchChangesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Pledge Price Changes
 */
export const pledgePriceChanges = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/pledge-price-changes`, method: 'GET', signal
    },
      );
    }




export const getPledgePriceChangesQueryKey = () => {
    return [
    'stats','pledge-price-changes'
    ] as const;
    }


export const getPledgePriceChangesQueryOptions = <TData = Awaited<ReturnType<typeof pledgePriceChanges>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pledgePriceChanges>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getPledgePriceChangesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof pledgePriceChanges>>> = ({ signal }) => pledgePriceChanges(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof pledgePriceChanges>>, TError, TData>
}

export type PledgePriceChangesQueryResult = NonNullable<Awaited<ReturnType<typeof pledgePriceChanges>>>
export type PledgePriceChangesQueryError = ErrorType<unknown>


/**
 * @summary Stats Pledge Price Changes
 */

export function usePledgePriceChanges<TData = Awaited<ReturnType<typeof pledgePriceChanges>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof pledgePriceChanges>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getPledgePriceChangesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats
 */
export const stats = (

 signal?: AbortSignal
) => {


      return axiosClient<Stats>(
      {url: `/stats/quick-stats`, method: 'GET', signal
    },
      );
    }




export const getStatsQueryKey = () => {
    return [
    'stats','quick-stats'
    ] as const;
    }


export const getStatsQueryOptions = <TData = Awaited<ReturnType<typeof stats>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stats>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getStatsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof stats>>> = ({ signal }) => stats(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof stats>>, TError, TData>
}

export type StatsQueryResult = NonNullable<Awaited<ReturnType<typeof stats>>>
export type StatsQueryError = ErrorType<unknown>


/**
 * @summary Stats
 */

export function useStats<TData = Awaited<ReturnType<typeof stats>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof stats>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getStatsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Ships of the Month
 */
export const shipsOfTheMonth = (
    params?: MaybeRefOrGetter<ShipsOfTheMonthParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<BarChartStatsList>(
      {url: `/stats/ships-of-the-month`, method: 'GET',
        params, signal
    },
      );
    }




export const getShipsOfTheMonthQueryKey = (params?: MaybeRefOrGetter<ShipsOfTheMonthParams>,) => {
    return [
    'stats','ships-of-the-month', ...(params ? [params] : [])
    ] as const;
    }


export const getShipsOfTheMonthQueryOptions = <TData = Awaited<ReturnType<typeof shipsOfTheMonth>>, TError = ErrorType<ValidationError>>(params?: MaybeRefOrGetter<ShipsOfTheMonthParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipsOfTheMonth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getShipsOfTheMonthQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof shipsOfTheMonth>>> = ({ signal }) => shipsOfTheMonth(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof shipsOfTheMonth>>, TError, TData>
}

export type ShipsOfTheMonthQueryResult = NonNullable<Awaited<ReturnType<typeof shipsOfTheMonth>>>
export type ShipsOfTheMonthQueryError = ErrorType<ValidationError>


/**
 * @summary Stats Ships of the Month
 */

export function useShipsOfTheMonth<TData = Awaited<ReturnType<typeof shipsOfTheMonth>>, TError = ErrorType<ValidationError>>(
 params?: MaybeRefOrGetter<ShipsOfTheMonthParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof shipsOfTheMonth>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getShipsOfTheMonthQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Top Paints
 */
export const topPaints = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/top-paints`, method: 'GET', signal
    },
      );
    }




export const getTopPaintsQueryKey = () => {
    return [
    'stats','top-paints'
    ] as const;
    }


export const getTopPaintsQueryOptions = <TData = Awaited<ReturnType<typeof topPaints>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof topPaints>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTopPaintsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof topPaints>>> = ({ signal }) => topPaints(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof topPaints>>, TError, TData>
}

export type TopPaintsQueryResult = NonNullable<Awaited<ReturnType<typeof topPaints>>>
export type TopPaintsQueryError = ErrorType<unknown>


/**
 * @summary Stats Top Paints
 */

export function useTopPaints<TData = Awaited<ReturnType<typeof topPaints>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof topPaints>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTopPaintsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Trending Ships
 */
export const trendingShips = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/trending-ships`, method: 'GET', signal
    },
      );
    }




export const getTrendingShipsQueryKey = () => {
    return [
    'stats','trending-ships'
    ] as const;
    }


export const getTrendingShipsQueryOptions = <TData = Awaited<ReturnType<typeof trendingShips>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trendingShips>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getTrendingShipsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof trendingShips>>> = ({ signal }) => trendingShips(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof trendingShips>>, TError, TData>
}

export type TrendingShipsQueryResult = NonNullable<Awaited<ReturnType<typeof trendingShips>>>
export type TrendingShipsQueryError = ErrorType<unknown>


/**
 * @summary Stats Trending Ships
 */

export function useTrendingShips<TData = Awaited<ReturnType<typeof trendingShips>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof trendingShips>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTrendingShipsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Vehicles by Model
 */
export const vehiclesByModel = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/vehicles-by-model`, method: 'GET', signal
    },
      );
    }




export const getVehiclesByModelQueryKey = () => {
    return [
    'stats','vehicles-by-model'
    ] as const;
    }


export const getVehiclesByModelQueryOptions = <TData = Awaited<ReturnType<typeof vehiclesByModel>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehiclesByModel>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehiclesByModelQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehiclesByModel>>> = ({ signal }) => vehiclesByModel(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehiclesByModel>>, TError, TData>
}

export type VehiclesByModelQueryResult = NonNullable<Awaited<ReturnType<typeof vehiclesByModel>>>
export type VehiclesByModelQueryError = ErrorType<unknown>


/**
 * @summary Stats Vehicles by Model
 */

export function useVehiclesByModel<TData = Awaited<ReturnType<typeof vehiclesByModel>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehiclesByModel>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehiclesByModelQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Vehicles per Month
 */
export const vehiclesPerMonth = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/vehicles-per-month`, method: 'GET', signal
    },
      );
    }




export const getVehiclesPerMonthQueryKey = () => {
    return [
    'stats','vehicles-per-month'
    ] as const;
    }


export const getVehiclesPerMonthQueryOptions = <TData = Awaited<ReturnType<typeof vehiclesPerMonth>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehiclesPerMonth>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehiclesPerMonthQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehiclesPerMonth>>> = ({ signal }) => vehiclesPerMonth(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehiclesPerMonth>>, TError, TData>
}

export type VehiclesPerMonthQueryResult = NonNullable<Awaited<ReturnType<typeof vehiclesPerMonth>>>
export type VehiclesPerMonthQueryError = ErrorType<unknown>


/**
 * @summary Stats Vehicles per Month
 */

export function useVehiclesPerMonth<TData = Awaited<ReturnType<typeof vehiclesPerMonth>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehiclesPerMonth>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehiclesPerMonthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Wish to Own Ratio
 */
export const wishToOwnRatio = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/wish-to-own-ratio`, method: 'GET', signal
    },
      );
    }




export const getWishToOwnRatioQueryKey = () => {
    return [
    'stats','wish-to-own-ratio'
    ] as const;
    }


export const getWishToOwnRatioQueryOptions = <TData = Awaited<ReturnType<typeof wishToOwnRatio>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wishToOwnRatio>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getWishToOwnRatioQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof wishToOwnRatio>>> = ({ signal }) => wishToOwnRatio(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wishToOwnRatio>>, TError, TData>
}

export type WishToOwnRatioQueryResult = NonNullable<Awaited<ReturnType<typeof wishToOwnRatio>>>
export type WishToOwnRatioQueryError = ErrorType<unknown>


/**
 * @summary Stats Wish to Own Ratio
 */

export function useWishToOwnRatio<TData = Awaited<ReturnType<typeof wishToOwnRatio>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wishToOwnRatio>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWishToOwnRatioQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Stats Wishlist by Model
 */
export const wishlistByModel = (

 signal?: AbortSignal
) => {


      return axiosClient<BarChartStatsList>(
      {url: `/stats/wishlist-by-model`, method: 'GET', signal
    },
      );
    }




export const getWishlistByModelQueryKey = () => {
    return [
    'stats','wishlist-by-model'
    ] as const;
    }


export const getWishlistByModelQueryOptions = <TData = Awaited<ReturnType<typeof wishlistByModel>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wishlistByModel>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getWishlistByModelQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof wishlistByModel>>> = ({ signal }) => wishlistByModel(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof wishlistByModel>>, TError, TData>
}

export type WishlistByModelQueryResult = NonNullable<Awaited<ReturnType<typeof wishlistByModel>>>
export type WishlistByModelQueryError = ErrorType<unknown>


/**
 * @summary Stats Wishlist by Model
 */

export function useWishlistByModel<TData = Awaited<ReturnType<typeof wishlistByModel>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof wishlistByModel>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getWishlistByModelQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






